class AdpInputController {
  constructor() {
    this.name = 'adpInput';
    this.tooltipOpen = false;
    this.isSelected = false;
  }
  openTooltip() {
    this.tooltipOpen = !this.tooltipOpen;
  }
  addSelected() {
    this.isSelected = true;
  }
  removeSelected() {
    this.isSelected = false;
  }
}

export default AdpInputController;



// WEBPACK FOOTER //
// ./src/app/components/adpInput/adpInput.controller.js